/**
 * /get: the one link we print as a QR code and put in posts. An iPhone goes straight to the App
 * Store, an Android phone straight to Google Play; anything else (a laptop) sees both badges.
 */
import React, { useEffect, useState } from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../pages/homepage/constants/homeLayoutsText";
import { storeForThisPhone } from "../pages/homepage/components/home3/chrome";
import logoMark from "../../assets/brand/logo_site.svg";

const GetAppPage: React.FC = () => {
  const [stay, setStay] = useState(false);
  useEffect(() => {
    const store = storeForThisPhone();
    if (store) window.location.replace(store);
    else setStay(true);
  }, []);
  return (
    <div style={{ minHeight: "100vh", background: "#0d0a0b", color: "#f4ede4", display: "grid", placeItems: "center", padding: "32px 16px", fontFamily: "Outfit, system-ui, sans-serif", textAlign: "center" }}>
      <div style={{ display: "grid", justifyItems: "center", gap: 20 }}>
        <img src={logoMark} alt="CherryClipz" height={64} style={{ width: "auto" }} />
        <h1 style={{ margin: 0, fontSize: 34, letterSpacing: "-0.03em" }}>Get CherryClipz</h1>
        {stay && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center", alignItems: "center" }}>
            <a href={APP_STORE_URL}>
              <img src="/app/appstore-badge-white.svg" alt="Download on the App Store" style={{ height: 48, display: "block" }} />
            </a>
            <a href={PLAY_STORE_URL}>
              <img src="/app/googleplay-badge.png" alt="Get it on Google Play" style={{ height: 70, margin: "-11px -10px", display: "block" }} />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default GetAppPage;
